import React, { ReactNode } from 'react'
import { ConfirmDialog } from 'shared/ui'
import { useBlocker } from 'infrastructure/routing'

export function NavigationBlock({
  shouldBlock,
  onProceedAnyway,
  children,
}: {
  shouldBlock: boolean
  onProceedAnyway: () => void // Need to clean up the blocked state
  children: ReactNode
}) {
  const blocker = useBlocker(shouldBlock)

  const onProceed = () => {
    onProceedAnyway()
    blocker.proceed?.()
  }

  if (blocker.state === 'blocked') {
    return (
      <ConfirmDialog
        title={'Navigation Blocked'}
        onClose={blocker.reset}
        onConfirm={onProceed}
        cta="Proceed"
        cancel="Stay On Page"
      >
        {children}
      </ConfirmDialog>
    )
  }

  return null
}
